<template>
<!--navUser-->
  <div class="main-headUser">
      <a href="#">Support and FAQs</a>
      <hr class="vertical">
      <a href="#">Contacts</a>
      <hr class="vertical">
      <h5> Current User: &emsp; </h5>
      <a href="#" class="userLog">  Last, First </a>
  </div>
</template>

<script>

export default {
  components: {

  }
}
</script>
<style scoped>
.userLog {
  color: #666;
}
</style>
